// Renderer registry — FXC-8538 (Warp).
//
// Lets surfaces refer to a renderer by name (`"force"`) or register
// their own. `<ThreadGraph renderer="force">` resolves through here;
// `<ThreadGraph renderer={MyRenderer}>` bypasses it. Built-ins register
// themselves on import of the react entry point.

import type { GraphRenderer } from "./GraphRenderer";

const registry = new Map<string, GraphRenderer>();

/** Register (or replace) a renderer under `name`. */
export function registerRenderer(name: string, renderer: GraphRenderer): void {
  registry.set(name, renderer);
}

/** Look up a renderer by name. Returns `undefined` if unregistered. */
export function getRenderer(name: string): GraphRenderer | undefined {
  return registry.get(name);
}

/** Names of all registered renderers. */
export function rendererNames(): string[] {
  return [...registry.keys()];
}
